import React from "react";

export default function About() {
  return (
    <section className="section">
      <h2>About</h2>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas mattis, tortor ut posuere aliquam, velit odio tristique risus,
        a finibus odio mauris in justo. Suspendisse potenti. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae;
        Quisque volutpat condimentum velit.
      </p>
      <p>
        Phasellus gravida semper nisi. Nullam vel sem. Pellentesque libero tortor, tincidunt et, tincidunt eget, semper nec, quam.
      </p>
    </section>
  );
}


